module.exports = __webpack_public_path__ + "img/emprendimiento-comunitario.825179c2.jpeg";